<template>
  <v-card tile class="d-flex justify-start elevation-0 pl-1">
    <v-select
      :items="wsGOSTItems"
      item-text="GOST_NAME"
      item-value="GOST_ID"
      :value="value"
      @input="setValue"
      label="ГОСТ"
      :readonly="readonly"
      :hint= "`${value ? value.GOST_CODE : ''}`"
      persistent-hint
      no-data-text="Нет данных"
      return-object
      class="elevation-0"
    ></v-select>
  </v-card>
</template>

<script>
import { RCPT_GET_GOST_LIST, RCPT_SET_FILTER } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
export default {
  name: 'wsGOSTSelector',
  props: ['FT_ID', 'setGlobalFilter', 'asFilter', 'value', 'readonly'],
  data () {
    return {
      wsGOSTItems: []
    }
  },
  watch: {
    FT_ID (val) {
      console.log('wsGOSTSelector: FT changed', val)
      this.getGOSTList()
    }
  },
  computed: {
  },
  methods: {
    setValue (val) {
      console.log('wsGOSTSelector:: setValue, GOST changed', val)
      if (this.setGlobalFilter) this.$store.dispatch(RCPT_SET_FILTER, { GOST_ID: val ? val.GOST_ID : null })
      this.$emit('input', val || null)
    },
    getGOSTList () {
      console.log('wsGOSTSelector:: getGOSTList called for FT_ID ', this.FT_ID)
      const self = this
      this.$store.dispatch(RCPT_GET_GOST_LIST, { FT_ID: this.FT_ID })
        .then((resp) => {
          const items = this.asFilter ? resp : resp.filter(itm => itm.GOST_ID !== '-5')
          self.wsGOSTItems.splice(0, self.wsGOSTItems.length, ...items)
          if (!self.FT_ID || self.FT_ID === '-5') {
            console.log('No FT_ID set, setting first')
            if (self.asFilter) self.setValue(self.wsGOSTItems[0])
          }
        })
        .catch((err) => {
          self.wsGOSTItems.splice(0, self.wsGOSTItems.length)
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка ГОСТов для типа рецептур: \n ${err}` })
        })
    }
  },

  mounted: function () {
    console.log('wsGOSTSelector mounted with value ', this.value)
    if (this.wsGOSTItems.length === 0) {
      this.getGOSTList()
    }
  },
  created () {
    console.log('wsGOSTSelector created with value ', this.value)
  }
}
</script>
